import React, { useMemo } from 'react'
import { AddressSelectCreatable } from '@ztechapps/webui.location'
import { useCustomerAddress } from '@ztechapps/customer.common'
import isBoolean from 'lodash/isBoolean'
import type { CustomerAddressProps } from '@ztechapps/webui.contract'

export const CustomerAddress = ({ filter, limit, sort, showAll, ...rest }: CustomerAddressProps) => {
  const { list } = useCustomerAddress({ filter, limit, sort })

  const options = useMemo(() => {
    if (isBoolean(showAll)) {
      if (showAll) return [...(list ?? []), { fullAddress: 'Show own addresses only.', showAll: false }]
      return [...(list ?? []), { fullAddress: 'Show addresses from other contacts within the company.', showAll: true }]
    }
    return list
  }, [list, showAll])

  return <AddressSelectCreatable options={options} {...rest} />
}
